import { useNavigate } from "react-router-dom";

/** Stay on the current screen and let the user choose whether to open plans. */
const SubscribeRequiredPrompt = ({ open, onClose }) => {
  const navigate = useNavigate();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="sub-need">
        <div className="ic">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <h3>No active subscription</h3>
        <p>
          Wallet recharge only pays for messages. Subscribe to a plan first to
          connect a WhatsApp number and unlock broadcasting, templates, flows and the AI chatbot.
        </p>
        <div className="acts">
          <button type="button" className="ping-btn ping-btn-ghost" onClick={onClose}>
            Not now
          </button>
          <button
            type="button"
            className="ping-btn ping-btn-green"
            onClick={() => {
              onClose?.();
              navigate("/subscribe");
            }}
          >
            View plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscribeRequiredPrompt;
